import React from "react";
import { FaChalkboardTeacher, FaUserGraduate, FaQuestionCircle, FaCogs } from "react-icons/fa";
import SectionHeading from "../shared/SectionHeading";

const HowToApply = ({ data }) => {
  if (!data.section[12].isActive) {
    return null;
  }

  return (
    <div
      className="py-16 px-6 md:px-12 lg:px-20"
      style={{
        background:
          "#c9dbff73",
      }}
    >
      {/* Section Title */}
      <SectionHeading>
        <span className="text-primary-color">How Mentorsity</span>{" "}
        <span className="text-secondary-color">Can Help</span>
      </SectionHeading>

      {/* Grid Layout without cards */}
      <div className="max-w-7xl mx-auto mt-12 grid grid-cols-1 md:grid-cols-2 gap-10">
        {[
          {
            icon: <FaChalkboardTeacher className="text-white w-6 h-6" />,
            desc: "Analyze successful industry scenarios to understand practical concepts.",
          },
          {
            icon: <FaUserGraduate className="text-white w-6 h-6" />,
            desc: "Our courses stay ahead of the curve, delivering industry-expert sessions.",
          },
          {
            icon: <FaCogs className="text-white w-6 h-6" />,
            desc: "Uncover your career path with one-on-one coaching from professionals.",
          },
          {
            icon: <FaQuestionCircle className="text-white w-6 h-6" />,
            desc: "Reach out to us for any queries and guidance via email.",
          },
        ].map((item, index) => (
          <div key={index} className="flex items-start gap-5">
            {/* Icon Circle */}
            <div className="min-w-[50px] min-h-[50px] bg-[#04236B] rounded-md flex items-center justify-center">
              {item.icon}
            </div>
            {/* Description Text */}
            <p className="text-gray-700 text-[14px] md:text-[16px] font-medium">
              {item.desc}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowToApply;
